import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LocalInterfaceService } from '../../../services/local-inteface-service/local-interface.service';
import { ToastrService } from 'ngx-toastr';
import { ValidationService } from '../../../services/validation-service/validation.service';
import { StorageService } from '../../../services/storege-service/storage.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-create-tournament-form',
  templateUrl: './create-tournament-form.component.html',
  styleUrls: ['./create-tournament-form.component.scss'],
})
export class CreateTournamentFormComponent implements OnInit {
  tournamentFormGeneral: FormGroup;
  public isLoading: boolean = false;
  public imageUrl: string | ArrayBuffer | null = null;
  uploadedImage: File;
  public imageSignedURL = '';
  public s3UploadedImage = '';

  constructor(
    private fb: FormBuilder,
    private localInterfaceSrv: LocalInterfaceService,
    private toastr: ToastrService,
    private validationSrv: ValidationService,
    public router: Router,
    private storageSrv: StorageService,

  ) { }

  ngOnInit(): void {
    this.validationSrv.validateAcess().then(async () => {
      // this.createForm();
    });
    this.createForm();
  }
  onFileSelected = async (event: any) => {
    const file: File = event.target.files[0];
    await this.getSignedURLForImage(file);
    if (file) {
      const reader: FileReader = new FileReader();
      reader.onload = (e: any) => {
        this.imageUrl = e.target.result;
      };
      reader.readAsDataURL(file);
    }
  };

  createForm(): void {
    this.tournamentFormGeneral = this.fb.group({
      type: ['', Validators.required],
      nameEn: ['', Validators.required],
      nameAr: ['', Validators.required],
      descriptionEn: ['Padel, double', Validators.required],
      descriptionAr: ['بادل ثنائي', Validators.required],
      tournamentDescEn: ['League', Validators.required],
      tournamentDescAr: ['بطولة', Validators.required],
      tournamentTypeEn: ['Padel', Validators.required],
      tournamentTypeAr: ['بادل', Validators.required],
      tournamentType: ['', Validators.required],
      level: ['', Validators.required],
      gender: ['', Validators.required],
      registrationStartDate: [new Date(), Validators.required],
      registrationEndDate: [new Date(), Validators.required],
      fromDate: [new Date(), Validators.required],
      toDate: [new Date(), Validators.required],
      noOfGroups: ['', [Validators.required, Validators.pattern(/^\d+$/)]],
      noOfTeamsPerGroup: [
        '',
        [Validators.required, Validators.pattern(/^\d+$/)],
      ],
      noOfRounds: ['', [Validators.required, Validators.pattern(/^\d+$/)]],
      noOfQualifiedTeams: [
        '',
        [Validators.required, Validators.pattern(/^\d+$/)],
      ],
      noOfDisqualifiedTeams: [
        '',
        [Validators.required, Validators.pattern(/^\d+$/)],
      ],
      noOfTeams: ['', [Validators.required, Validators.pattern(/^\d+$/)]],
      noOfTeamsJoined: [
        '0',
        [Validators.required, Validators.pattern(/^\d+$/)],
      ],
      tournamentLogo: ['null', Validators.required],
      facilityIds: [[parseInt(this.storageSrv.getFacilityId())]]
    });
  }

  get f() {
    return this.tournamentFormGeneral.controls;
  }
  onDateChange(date: Date, type): void {
    if (type.includes('registrationStartDate')) {
      // Set time to 00:00:00
      this.f['registrationStartDate'].setValue(new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate() + 1,
        0, // Hours
        0, // Minutes
        0, // Seconds
        0  // Milliseconds
      ));
      console.log('Updated Date:', date);
    } 
    if (type.includes('registrationEndDate')) {
      // Set time to 00:00:00
      this.f['registrationEndDate'].setValue(new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate() + 1,
        0, // Hours
        0, // Minutes
        0, // Seconds
        0  // Milliseconds
      ));
      console.log('Updated Date:', date);
    } 
    if (type.includes('fromDate')) {
      // Set time to 00:00:00
      this.f['fromDate'].setValue(new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate() + 1,
        0, // Hours
        0, // Minutes
        0, // Seconds
        0  // Milliseconds
      ));
      console.log('Updated Date:', date);
    } 
    if (type.includes('toDate')) {
      // Set time to 00:00:00
      this.f['toDate'].setValue(new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate() + 1,
        0, // Hours
        0, // Minutes
        0, // Seconds
        0  // Milliseconds
      ));
      console.log('Updated Date:', date);
    } 
  }

  onSubmit(): void {
    if (this.tournamentFormGeneral.valid) {
      // Process the form data
      console.log(this.tournamentFormGeneral.value);
      // if (!this.s3UploadedImage) {
      //   this.toastr.error('Upload Tournament Logo Image First');
      //   return;
      // }

      this.saveTournamentData();
    } else {
      // Form is invalid, show error messages
      this.markFormGroupTouched(this.tournamentFormGeneral);
    }
  }

  saveTournamentData = () => {
    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      this.localInterfaceSrv
        .saveTournament(this.tournamentFormGeneral.value)
        .then(async (res) => {
          this.toastr.success('Tournament saved successfully');
          this.router.navigate([`tournaments`]);

          this.isLoading = false;

          resolve(res);
        })
        .catch((err) => {
          reject(err);
          console.log(err);
          this.toastr.error(err.description, 'Error');
        })
        .finally(() => {
          this.isLoading = false;
        });
    });
  };

  getSignedURLForImage = (file: File) => {
    const fileExtArray = file.type.split('/');
    let fileExt = fileExtArray[fileExtArray.length - 1];

    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      this.localInterfaceSrv
        .getSignedURL(fileExt, file.type)
        .then(async (res) => {
          this.imageSignedURL = res.data.content;
          await this.uploadFileToS3(res.data.content, file);
          this.isLoading = false;

          resolve(res);
        })
        .catch((err) => {
          reject(err);
          console.log(err);
          // this.toastr.error(err.description, "Error");
        })
        .finally(() => {
          this.isLoading = false;
        });
    });
  };

  uploadFileToS3 = (uploadURL, file) => {
    return new Promise<any>(async (resolve, reject) => {
      this.localInterfaceSrv
        .uploadImageFileToS3(uploadURL, file)
        .then(async (res) => {
          this.toastr.success('IMAGE uploaded');
          let url = new URL(uploadURL);
          url.search = '';
          console.log('Image URL', url.href);
          this.s3UploadedImage = url.href;
          this.tournamentFormGeneral.patchValue({
            tournamentLogo: url.href, // Update the tournamentLogo form control with the image URL
          });
          resolve(res);
        })
        .catch((err) => {
          reject(err);
          console.log(err);
          this.toastr.error('Error Upload Error');
        });
    });
  };

  markFormGroupTouched(formGroup: FormGroup): void {
    Object.values(formGroup.controls).forEach((control) => {
      control.markAsTouched();

      if (control instanceof FormGroup) {
        this.markFormGroupTouched(control);
      }
    });
  }

  positiveNumberValidator(control) {
    const value = control.value;
    if (value !== null && value !== undefined && value <= 0) {
      return { positiveNumber: true };
    }
    return null;
  }
}
